
export const cookiesNames = {
    language: 'language',
};